export const DELIVERY_METHOD_ADDRESS = 2
export const DELIVERY_METHOD_SELF = 1
